import styled from 'styled-components';

export const StyledSkeletonFile = styled.div`
  width: 100%;

  .skeleton-file-body {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 16px 25px 16px 25px;
    box-sizing: border-box;
    border-bottom: 1px solid #ebebeb;
    border-bottom: 1px solid #ebebeb;
    height: 80px;

    .icon-file-skeleton {
      width: 48px;
      height: 48px;
    }

    .name-file-skeleton {
      width: 224px;
      height: 19px;
    }

    .info-file-skeleton {
      width: 224px;
      height: 19px;
    }

    .action-file-skeleton {
      width: 140px;
      height: 19px;
    }
  }

  .container-skeleton {
    display: flex;
    align-items: center;
    gap: 32px;
  }

  .skeleton-file-actions {
    gap: 8px;
  }

  @media (max-width: 1024px) {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;

    box-sizing: border-box;
    .skeleton-file-body {
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      height: 80px;
      padding: 15px 8px 16px 8px;

      .container-skeleton {
        display: flex;
        align-items: center;
        gap: 4px;

        /* .icon-file-skeleton {
          margin-bottom: -16px;
        } */

        .name-file-skeleton {
          margin-left: 12px;
          height: 16px;
          margin-bottom: 24px;
        }
      }

      .info-file-skeleton {
        width: 108px;
        height: 16px;
      }

      .action-file-skeleton {
        width: 92px;
        height: 16px;
      }

      .skeleton-file-actions {
        margin-left: 65px;

        height: 16px;
        margin-top: -20px;
      }
    }
  }
`;
